<import name="RouterLink" from="rmlibrary/router" />
<import name="Collapsible" from="rmlibrary/collapsible" />
<import name="Scroll" from="rmlibrary/scroll" />
<import name="LearnMoreButton" from="../../common/learn-more-button.html" />

<style lang="scss">
    @import 'sass/variables';

    @mixin banner-img($url) {
        width: 100%;
        height: 100%;
        background-image: url($url);
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center;
        @media #{$xs-only} {
            background-position: bottom;
        }
        @media #{$sm-only} {
            background-position: 100% 73%;
        }
        @media #{$md-only} {
            min-height: 515px;
        }
    }

    .img-1 {
        @include banner-img('images/banner-bgs/interactive-fitness.jpg');

        @media #{$xs-only} {
            @include banner-img('images/banner-bgs/interactive-mobile-fitness.jpg');
        }
        
        @media #{$sm-only} {
            @include banner-img('images/banner-bgs/interactive-small-fitness.jpg');
        }
        
        @media #{$md-only} {
            min-height: 515px;
        }
    }

    .img-2 {
        @include banner-img('images/banner-bgs/interactive-ecommerce.jpg');

        @media #{$xs-only} {
            @include banner-img('images/banner-bgs/interactive-mobile-ecommerce.jpg');
        }
        
        @media #{$sm-only} {
            @include banner-img('images/banner-bgs/interactive-small-ecommerce.jpg');
        }
        
        @media #{$md-only} {
            min-height: 515px;
        }
    }

    .img-3 {
        @include banner-img('images/banner-bgs/interactive-mortgage.jpg');

        @media #{$xs-only} {
            @include banner-img('images/banner-bgs/interactive-mobile-mortgage.jpg');
        }
        
        @media #{$sm-only} {
            @include banner-img('images/banner-bgs/interactive-small-mortgage.jpg');
        }
        
        @media #{$md-only} {
            min-height: 515px;
        }
    }

    .img-4 {
        @include banner-img('images/banner-bgs/interactive-travel.jpg');

        @media #{$xs-only} {
            @include banner-img('images/banner-bgs/interactive-mobile-travel.jpg');
        }
        
        @media #{$sm-only} {
            @include banner-img('images/banner-bgs/interactive-small-travel.jpg');
        }
        
        @media #{$md-only} {
            min-height: 515px;
        }
    }
    
    .img-1-financial {
        @include banner-img('images/banner-bgs/interactive-fitness.jpg');

        @media #{$xs-only} {
            @include banner-img('images/banner-bgs/interactive-mobile-fitness.jpg');
        }
        
        @media #{$sm-only} {
            @include banner-img('images/banner-bgs/interactive-small-fitness.jpg');
        }
        
        @media #{$md-only} {
            min-height: 515px;
        }
    }
    
    .img-2-financial {
        @include banner-img('images/banner-bgs/interactive-retire.jpg');

        @media #{$xs-only} {
            @include banner-img('images/banner-bgs/interactive-mobile-retire.jpg');
        }
        
        @media #{$sm-only} {
            @include banner-img('images/banner-bgs/interactive-small-retire.jpg');

        }
        @media #{$md-only} {
            min-height: 515px;
        }
    }
    
    .img-3-financial {
        @include banner-img('images/banner-bgs/interactive-mortgage.jpg');

        @media #{$xs-only} {
            @include banner-img('images/banner-bgs/interactive-mobile-mortgage.jpg');
        }
        
        @media #{$sm-only} {
            @include banner-img('images/banner-bgs/interactive-small-mortgage.jpg');
        }
        
        @media #{$md-only} {
            min-height: 515px;
        }
    }

    .img-4-financial {
        @include banner-img('images/banner-bgs/interactive-travel.jpg');

        @media #{$xs-only} {
            @include banner-img('images/banner-bgs/interactive-mobile-travel.jpg');
        }
        
        @media #{$sm-only} {
            @include banner-img('images/banner-bgs/interactive-small-travel.jpg');
        }
        
        @media #{$md-only} {
            min-height: 515px;
        }
    }
    
    .img-1-pharma {
        @include banner-img('images/banner-bgs/interactive-fitness.jpg');
        @media #{$xs-only} {
            @include banner-img('images/banner-bgs/interactive-mobile-fitness.jpg');
        }
        @media #{$sm-only} {
            @include banner-img('images/banner-bgs/interactive-small-fitness.jpg');
        }
        @media #{$md-only} {
            min-height: 515px;
        }
    }
    
    .img-2-pharma {
        @include banner-img('images/banner-bgs/interactive-medtracker.jpg');
        @media #{$xs-only} {
            @include banner-img('images/banner-bgs/interactive-mobile-medtracker.jpg');
        }
        @media #{$sm-only} {
            @include banner-img('images/banner-bgs/interactive-small-medtracker.jpg');
        }
        @media #{$md-only} {
            min-height: 515px;
        }
    }
    
    .img-3-pharma {
        @include banner-img('images/banner-bgs/interactive-allergy.jpg');
        @media #{$xs-only} {
            @include banner-img('images/banner-bgs/interactive-mobile-allergy.jpg');
        }
        @media #{$sm-only} {
            @include banner-img('images/banner-bgs/interactive-small-allergy.jpg');
        }
        @media #{$md-only} {
            min-height: 515px;
        }
    }

    .img-4-pharma {
        @include banner-img('images/banner-bgs/interactive-stress.jpg');
        @media #{$xs-only} {
            @include banner-img('images/banner-bgs/interactive-mobile-stress.jpg');
        }
        @media #{$sm-only} {
            @include banner-img('images/banner-bgs/interactive-small-stress.jpg');
        }
        @media #{$md-only} {
            min-height: 515px;
        }
    }
    
    .gallery {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
    }

    .banner-interactive {
        position: relative;
        @media #{$md-only} {
            min-height: 515px;
        }
        .text {
            color: white;
            max-width: 450px;
            @media #{$md-only} {
                max-width: 368px;
            }
            @media #{$xs-only, $sm-only} {
                max-width: none;
                padding-top: 45px;
            }
        }
        .buttons {
            @media #{$xs-only, $sm-only} {
                padding-bottom: 352px;
            }
            @media #{$xs-only, $sm-only} {
                padding-bottom: 400px;
            }

            .selected {
                border: 1px solid $yellow;
                background-color: $yellow;
                .chevron {
                    color: $black;
                }
                &:hover {
                    background-color: $black;
                    border: 1px solid white;
                    border-style: inset;
                    color: $white;
                    transition: background-color 0.5s ease;
                }
            }
            .selected {
                background-color: $yellow;
                color: $black;
                border: 1px solid $yellow;
                .chevron {
                    color: $black;
                }
            }
            .yellow-button:hover .chevron {
                color: $black;
            }
            .black-button {
                background-color: $black90;
                color: white;
                border: 1px solid white;
                margin-left: 20px;
                @media #{$xs-only} {
                    margin-left: 5px;
                }
                .chevron {
                    color: $white;
                }
            }
        }
    }

    .controls {
        width: 100%;
        padding: 0 20px 30px;
        display: block;
        text-align: center;
        position: absolute;
        bottom: 0;
        .dots {
            width: 14px;
            height: 14px;
            border: 1px solid $black;
            border-radius: 100%;
            display: inline-block;
            vertical-align: middle;
            margin: 5px;
            border: 1px solid $white;
            background-color: $black;
            @media #{$sm-only, $xs-only} {
                width: 10px;
                height: 10px;
                margin: 4px;
            }
        }

        .selected-dot {
            background-color: $white;
            border: 1px solid $black;
        }
    }


    .learn-more {
        background-color: $yellow;
        padding-top: 60px;
        padding-bottom: 60px;
        padding-left: 20px;
        padding-right: 20px;
        @media #{$sm-only, $xs-only} {
            padding-top: 20px;
            padding-bottom: 20px;
        }
        .learn-more-content {
            display: flex;
            flex-wrap: wrap;
            width: 100%;
            max-width: 1100px;
            margin: 0 auto;
            justify-content: center;
            align-items: center;
            @media #{$sm-only, $xs-only} {
                align-items: inherit;
            }
            .item {
                width: 31%;
                text-align: center;
                padding: 10px;
                @media #{$sm-only, $xs-only} {
                    width: 50%;
                    font-size: 14px;
                }
                img {
                    width: 70px;
                    margin-bottom: 5px;
                    flex-shrink: 0;
                    -webkit-animation: pop-in 0.5s 0.2s both;
                    -moz-animation: pop-in 0.5s 0.2s both;
                    -ms-animation: pop-in 0.5s 0.2s both;
                    animation-delay: 0.7s;
                    @media #{$sm-only, $xs-only} {
                        width: 60px;
                    }
                }
                p {
                    -webkit-animation: fadeIn 1s 0.2s both;
                    -moz-animation: fadeIn 1s 0.2s both;
                    -ms-animation: fadeIn 1s 0.2s both;
                    animation-delay: 0.8s;
                }
            }
            .item-line {
                @media #{$sm-only, $xs-only} {
                    border-bottom: 1px solid $black90;
                    padding-bottom: 20px;
                    padding-top: 20px;
                    animation: grow-width3 0.5s 0.2s both;
                    animation-delay: 0.6s;
                }
            }
            .item3 {
                @media #{$sm-only, $xs-only} {
                    padding-top: 20px;
                    padding-bottom: 20px;
                    border-bottom: 1px solid $black90;
                    animation: grow-width3 0.5s 0.2s both;
                    animation-delay: 0.6s;
                }
            }
            .second-row {
                padding-top: 50px;
                @media #{$sm-only, $xs-only} {
                    padding-top: 20px;
                }
            }
            .line {
                max-width: 1px;
                width: 1%;
                height: 150px;
                background-color: $black90;
                animation: grow-height 0.5s 0.2s both;
                animation-delay: 0.6s;
                @media #{$sm-only, $xs-only} {
                    display: none;
                }
            }
            .line2 {
                margin-top: 50px;
            }
            .no-line {
                @media #{$sm-only, $xs-only} {
                    border: none;
                }
            }
            .lines {
                display: flex;
                justify-content: space-around;
                width: 100%;
                @media #{$sm-only, $xs-only} {
                    display: none;
                }
                .line-horizontal {
                    width: 33%;
                    height: 1px;
                    background-color: $black90;
                    margin-top: 50px;
                    max-width: 280px;
                    margin-right: 30px;
                    margin-left: 30px;
                    animation: grow-width2 0.5s 0.2s both;
                    animation-delay: 0.6s;
                }
            }
        }
        &.black {
            background-color: $black90;
            .learn-more-content {
                .item-line {
                    border-bottom: $white;
                }
                .item3 {
                    border-bottom: $white;
                }
                .line {
                    background-color: $white;
                }
                .lines {
                    .line-horizontal {
                        background-color: $white;
                    }
                }

                p {
                    color: $white;
                }

            }
        }
    }

  .screen_contain {
      position: relative;
        margin: 0 auto;
        max-width: 768px;
        width: 100%;
        padding-left: 20px;
        padding-right: 20px;
        display: flex;
        justify-content: flex-end;
        pointer-events: none;

        @media #{$xs-only} {
        }  
      
        /* @media #{$sm-only} {
                    opacity: 0;
        }   */
        
      @media #{$md-only} {
        
      }
      
    }
    
    .hand_contain {
        position: relative;
        margin-top: 50px;
        margin-right: -170px;
        
            @media #{$xs-only} {
                transform: scale(0.725);
                max-width: 768px;
                transform-origin: center;
                margin-top: 118px;
                margin-right: calc(50% - 346px);
            }
            @media #{$sm-only} {
                transform: scale(0.725);
                max-width: 768px;
                transform-origin: center;
                margin-top: 129px;
                margin-right: calc(50% - 346px);
            }
            @media #{$md-only} {
                transform: scale(0.824);
                margin-right: -145px;
                margin-top: -9px;
            }
        }
    
    .phone_vid {
        height: 293.5px;
        width: 163px;
        position: relative;
        bottom: -199px;
        left: 295px;
        transform-origin: center;
        background-size:contain;
    
        @media #{$xs-only}  {
            width: 153px;
            position: absolute;
            transform: scale(0.77);
            bottom: 147px;
            left: calc(50% - 72px);
            height: 275px;
        }
    
        @media #{$sm-only} {
            // width: 100%;
            position: absolute;
            transform: scale(0.725);
            bottom: 137px;
            left: calc(50% - 79px);
        }
        @media #{$md-only} {
            height: 240.5px;
            width: 134px;
            position: absolute;
            bottom: 164px;
            left: auto;
            right: 156px;
        }
        
        > video {
            position: absolute;
            top:0;
            left:0;
            width:100%;
            height:100%;
            display:none;

            .card-selected & {
                display: block;
            }
        }
        
    }
    
    .hand {
        @media #{$xs-only} {
            
        }

        @media #{$sm-only} {
        }
    }
</style>

<template name="InteractiveTools__" extends="InteractiveToolsController">
<div class="chevron-scroll-anchor">
    <div role="group" aria-labelledby="lbl-interactive" class="banner" style="position: relative">

        <div class="gallery">
            <If condition="{!this.props.specialIndustry}">
                <GalleryCarousel reveal="{!(!!navigator.userAgent.match(/Trident/g) || !!navigator.userAgent.match(/MSIE/g))}" draggable autoScroll="6000" callbefore="{this.galleryCallbefore}" ref="{carousel => this.gallery = carousel}">
                    <BannerItem class="img-1"
                        phoneVideoSrc="site_assets/videos/fitness_screen_vid.mp4"
                        phoneImgSrc="site_assets/videos/fitness_screen_vid.jpg"
                    />
                    <BannerItem class="img-2"
                        phoneVideoSrc="site_assets/videos/ecommerce_screen_vid.mp4"
                        phoneImgSrc="site_assets/videos/ecommerce_screen_vid.jpg"
                    />
                    <BannerItem class="img-3"
                        phoneVideoSrc="site_assets/videos/mortgage_screen_vid.mp4"
                        phoneImgSrc="site_assets/videos/mortgage_screen_vid.jpg"
                    />
                    <BannerItem class="img-4"
                        phoneVideoSrc="site_assets/videos/travel_screen_vid.mp4"
                        phoneImgSrc="site_assets/videos/travel_screen_vid.jpg"
                    />
                </GalleryCarousel>
            </If>            
            <!-- Financial Carousel -->
            <If condition="{this.props.industry == 'financial'}">
                <GalleryCarousel reveal="{!(!!navigator.userAgent.match(/Trident/g) || !!navigator.userAgent.match(/MSIE/g))}" draggable autoScroll="6000" callbefore="{this.galleryCallbefore}" ref="{carousel => this.gallery = carousel}">
                    <BannerItem class="img-1-financial"
                        phoneVideoSrc="site_assets/videos/financial_fitness_screen_vid.mp4"
                        phoneImgSrc="site_assets/videos/financial_fitness_screen_vid.jpg"
                    />
                    <BannerItem class="img-2-financial"
                        phoneVideoSrc="site_assets/videos/retire_screen_vid.mp4"
                        phoneImgSrc="site_assets/videos/retire_screen_vid.jpg"
                    />
                    <BannerItem class="img-3-financial"
                        phoneVideoSrc="site_assets/videos/mortgage_screen_vid.mp4"
                        phoneImgSrc="site_assets/videos/mortgage_screen_vid.jpg"
                    />
                    <BannerItem class="img-4-financial"
                        phoneVideoSrc="site_assets/videos/travel_screen_vid.mp4"
                        phoneImgSrc="site_assets/videos/travel_screen_vid.jpg"
                    />
                </GalleryCarousel>
            </If>
            <If condition="{this.props.industry == 'pharma'}">
                <GalleryCarousel reveal="{!(!!navigator.userAgent.match(/Trident/g) || !!navigator.userAgent.match(/MSIE/g))}" draggable autoScroll="6000" callbefore="{this.galleryCallbefore}" ref="{carousel => this.gallery = carousel}">
                    <BannerItem class="img-1-pharma"
                        phoneVideoSrc="site_assets/videos/pharma_fitness_screen_vid.mp4"
                        phoneImgSrc="site_assets/videos/pharma_fitness_screen_vid.jpg"
                    />
                    <BannerItem class="img-2-pharma"
                        phoneVideoSrc="site_assets/videos/med_tracker_screen_vid.mp4"
                        phoneImgSrc="site_assets/videos/med_tracker_screen_vid.jpg"
                    />
                    <BannerItem class="img-3-pharma"
                        phoneVideoSrc="site_assets/videos/allergy_screen_vid.mp4"
                        phoneImgSrc="site_assets/videos/allergy_screen_vid.jpg"
                    />
                    <BannerItem class="img-4-pharma"
                        phoneVideoSrc="site_assets/videos/stress_scanner_screen_vid.mp4"
                        phoneImgSrc="site_assets/videos/stress_scanner_screen_vid.jpg"
                    />
                </GalleryCarousel>
            </If>
        </div>

        <Scroll classInView="rm-timeline-banner-interactive-tools">
            <div class="content banner-interactive" style.pointerEvents="none">
                <div class="text">
                    <If condition="{!this.props.specialIndustry}">
                        <div>
                            <h2 id="lbl-interactive" class="title">Interactive Tools</h2>
                            <p class="copy"><span class="redact-white3">Engage</span> your users <span class="redact-white">with useful tools and widgets that help them </span> find exactly what they want, <span class="redact-white2"> when they want.</span></p>
                        </div>
                    </If>
                    <If condition="{this.props.industry === 'financial'}">
                        <div>
                            <h2 id="lbl-interactive" class="title">Financial Tools</h2>
                            <p class="copy"><span class="redact-white3">Engage</span> your users <span class="redact-white"> with financial tools and widgets that help them</span> see every possibility.</p>
                        </div>
                    </If>
                    <If condition="{this.props.industry === 'pharma'}">
                        <div>
                            <h2 id="lbl-interactive" class="title">Interactive Tools</h2>
                            <p class="copy"><span class="redact-white3">Engage</span> and educate your users <span class="redact-white"> with informative, gamified pharmaceutical tools and widgets that show them</span> exactly what they need to know.</p>
                        </div>
                    </If>

                    <div class="buttons buttons-yellow">
                        <LearnMoreButton selected="{this.state.isOpen}" onClick={this.toggleAccordion} />
                        <RouterLink
                            role="button"
                            style="{{pointerEvents: 'auto', position: 'relative'}}"
                            to="/portfolio"
                            query="{{f: 'interactive'}}"
                            className="yellow-button black-button"
                            onClick="{this.portfolioClick}"
                        >Portfolio <span class="chevron right"></span></RouterLink>
                    </div>
                </div>
            </div>
        </Scroll>    

        <div class="controls">
            <For var="card" of="{this.state.galleryImages}">
                <button key="{index}" onClick="{(e) => {this.indicatorsRedirect(card, index, e)}}"
                        class="dots" class.selected-dot="{index == this.state.index}"
                        ref="{btn => index == this.state.index ? this.selectedBtn = btn : ''}" aria-label="{'Slide ' + (index + 1)}"></button>
            </For>
        </div>
    </div>
    <Collapsible open={this.state.isOpen} duration="250" ease="easeInOut" onOpened={this.accordionOpened}>
        <div class="learn-more" ref={this.scrollRef} class.black="{this.props.theme === 'black'}" class.yellow="{this.props.theme === 'yellow'}">
            <If condition="{!this.props.specialIndustry}">
                <div class="learn-more-content">
                    <div class="item item-line">
                        <img src="{`site_assets/images/icons/SVG/calculators-icon-${this.props.theme === 'yellow' ? 'black' : 'yellow'}.svg`}" width="70px" height="70px" aria-labelledby="interactive-calculator-icon"/>
                        <p id="interactive-calculator-icon"><span class.redact-white2="{this.props.theme !== 'yellow'}" class.redact2="{this.props.theme === 'yellow'}">Financial calculators</span></p>
                    </div>
                    <div class="line"></div>
                    <div class="item item-line">
                        <img src="{`site_assets/images/icons/SVG/quizzes-icon-${this.props.theme === 'yellow' ? 'black' : 'yellow'}.svg`}" width="70px" height="70px" aria-labelledby="interactive-quiz-icon"/>
                        <p id="interactive-quiz-icon"><span class.redact-white2="{this.props.theme !== 'yellow'}" class.redact2="{this.props.theme === 'yellow'}">Quizzes &amp; questionnaires</span></p>
                    </div>
                    <div class="line"></div>
                    <div class="item item3">
                        <img src="{`site_assets/images/icons/SVG/investments-icon-${this.props.theme === 'yellow' ? 'black' : 'yellow'}.svg`}" width="70px" height="70px" aria-labelledby="interactive-investment-icon"/>
                        <p id="interactive-investment-icon"><span class.redact-white2="{this.props.theme !== 'yellow'}" class.redact2="{this.props.theme === 'yellow'}">Investment illustrators</span></p>
                    </div>

                    <div class="lines">
                        <div class="line-horizontal"></div>
                        <div class="line-horizontal"></div>
                        <div class="line-horizontal"></div>
                    </div>

                    <div class="item item-line second-row">
                        <img src="{`site_assets/images/icons/SVG/games-icon-${this.props.theme === 'yellow' ? 'black' : 'yellow'}.svg`}" width="70px" height="70px" aria-labelledby="interactive-games-icon"/>
                        <p id="interactive-games-icon"><span class.redact-white2="{this.props.theme !== 'yellow'}" class.redact2="{this.props.theme === 'yellow'}">Educational tools &amp; games</span></p>
                    </div>
                    <div class="line line2"></div>
                    <div class="item item-line second-row no-line">
                        <img src="{`site_assets/images/icons/SVG/live-feed-icon-${this.props.theme === 'yellow' ? 'black' : 'yellow'}.svg`}" width="70px" height="70px" aria-labelledby="interactive-liveFeeds-icon"/>
                        <p id="interactive-liveFeeds-icon"><span class.redact-white3="{this.props.theme !== 'yellow'}" class.redact3="{this.props.theme === 'yellow'}">Live feeds</span></p>
                    </div>
                    <div class="line line2"></div>
                    <div class="item item3 second-row no-line">
                        <img src="{`site_assets/images/icons/SVG/pdf-icon-${this.props.theme === 'yellow' ? 'black' : 'yellow'}.svg`}" width="70px" height="70px" aria-labelledby="interactive-pdf-icon"/>
                        <p id="interactive-pdf-icon"><span class.redact-white2="{this.props.theme !== 'yellow'}" class.redact2="{this.props.theme === 'yellow'}">Custom PDFs and printable reports</span></p>
                    </div>
                </div>
            </If>

            <If condition="{this.props.industry == 'financial'}">
                <div class="learn-more-content">
                    <div class="item item-line">
                        <img src="{`site_assets/images/icons/SVG/calculators-icon-${this.props.theme === 'yellow' ? 'black' : 'yellow'}.svg`}" width="70px" height="70px" aria-labelledby="interactive-calculator-icon"/>
                        <p id="interactive-calculator-icon"><span class.redact-white2="{this.props.theme !== 'yellow'}" class.redact2="{this.props.theme === 'yellow'}">Financial calculators</span></p>
                    </div>
                    <div class="line"></div>
                    <div class="item item-line">
                        <img src="{`site_assets/images/icons/SVG/quizzes-icon-${this.props.theme === 'yellow' ? 'black' : 'yellow'}.svg`}" width="70px" height="70px" aria-labelledby="interactive-quiz-icon"/>
                        <p id="interactive-quiz-icon"><span class.redact-white2="{this.props.theme !== 'yellow'}" class.redact2="{this.props.theme === 'yellow'}">Quizzes &amp; questionnaires</span></p>
                    </div>
                    <div class="line"></div>
                    <div class="item item3">
                        <img src="{`site_assets/images/icons/SVG/investments-icon-${this.props.theme === 'yellow' ? 'black' : 'yellow'}.svg`}" width="70px" height="70px" aria-labelledby="interactive-investment-icon"/>
                        <p id="interactive-investment-icon"><span class.redact-white2="{this.props.theme !== 'yellow'}" class.redact2="{this.props.theme === 'yellow'}">Investment illustrators</span></p>
                    </div>

                    <div class="lines">
                        <div class="line-horizontal"></div>
                        <div class="line-horizontal"></div>
                        <div class="line-horizontal"></div>
                    </div>

                    <div class="item item-line second-row">
                        <img src="{`site_assets/images/icons/SVG/games-icon-${this.props.theme === 'yellow' ? 'black' : 'yellow'}.svg`}" width="70px" height="70px" aria-labelledby="interactive-games-icon"/>
                        <p id="interactive-games-icon"><span class.redact-white2="{this.props.theme !== 'yellow'}" class.redact2="{this.props.theme === 'yellow'}">Educational tools &amp; games</span></p>
                    </div>
                    <div class="line line2"></div>
                    <div class="item item-line second-row no-line">
                        <img src="{`site_assets/images/icons/SVG/live-feed-icon-${this.props.theme === 'yellow' ? 'black' : 'yellow'}.svg`}" width="70px" height="70px" aria-labelledby="interactive-liveFeeds-icon"/>
                        <p id="interactive-liveFeeds-icon"><span class.redact-white3="{this.props.theme !== 'yellow'}" class.redact3="{this.props.theme === 'yellow'}">Live feeds</span></p>
                    </div>
                    <div class="line line2"></div>
                    <div class="item item3 second-row no-line">
                        <img src="{`site_assets/images/icons/SVG/pdf-icon-${this.props.theme === 'yellow' ? 'black' : 'yellow'}.svg`}" width="70px" height="70px" aria-labelledby="interactive-pdf-icon"/>
                        <p id="interactive-pdf-icon"><span class.redact-white2="{this.props.theme !== 'yellow'}" class.redact2="{this.props.theme === 'yellow'}">Custom PDFs and printable reports</span></p>
                    </div>
                </div>
            </If>
                
            <If condition="{this.props.industry == 'pharma'}">
                <div class="learn-more-content">
                    <div class="item item-line">
                        <img src="{`site_assets/images/icons/SVG/e-detail-${this.props.theme === 'yellow' ? 'black' : 'yellow'}.svg`}" width="70px" height="70px" aria-labelledby="interactive-calculator-icon"/>
                        <p id="interactive-calculator-icon"><span class.redact-white2="{this.props.theme !== 'yellow'}" class.redact2="{this.props.theme === 'yellow'}">Interactive e-detailing</span></p>
                    </div>
                    <div class="line"></div>
                    <div class="item item-line">
                        <img src="{`site_assets/images/icons/SVG/live-feed-icon-${this.props.theme === 'yellow' ? 'black' : 'yellow'}.svg`}" width="70px" height="70px" aria-labelledby="interactive-liveFeeds-icon"/>
                        <p id="interactive-liveFeeds-icon"><span class.redact-white2="{this.props.theme !== 'yellow'}" class.redact2="{this.props.theme === 'yellow'}">Product selectors</span></p>
                    </div>
                    <div class="line"></div>
                    <div class="item item3">
                        <img src="{`site_assets/images/icons/SVG/disease-${this.props.theme === 'yellow' ? 'black' : 'yellow'}.svg`}" width="70px" height="70px" aria-labelledby="interactive-investment-icon"/>
                        <p id="interactive-investment-icon"><span class.redact-white2="{this.props.theme !== 'yellow'}" class.redact2="{this.props.theme === 'yellow'}">Disease assessment tools</span></p>
                    </div>

                    <div class="lines">
                        <div class="line-horizontal"></div>
                        <div class="line-horizontal"></div>
                        <div class="line-horizontal"></div>
                    </div>

                    <div class="item item-line second-row">
                        <img src="{`site_assets/images/icons/SVG/grad-cap-${this.props.theme === 'yellow' ? 'black' : 'yellow'}.svg`}" width="70px" height="70px" aria-labelledby="interactive-games-icon"/>
                        <p id="interactive-games-icon"><span class.redact-white2="{this.props.theme !== 'yellow'}" class.redact2="{this.props.theme === 'yellow'}">Education &amp; games</span></p>
                    </div>
                    <div class="line line2"></div>
                    <div class="item item-line second-row no-line">
                        <img src="{`site_assets/images/icons/SVG/pill-tracking-${this.props.theme === 'yellow' ? 'black' : 'yellow'}.svg`}" width="70px" height="70px" aria-labelledby="interactive-quiz-icon"/>
                        <p id="interactive-quiz-icon"><span class.redact-white3="{this.props.theme !== 'yellow'}" class.redact3="{this.props.theme === 'yellow'}">Medication adherence apps</span></p>
                    </div>
                    <div class="line line2"></div>
                    <div class="item item3 second-row no-line">
                        <img src="{`site_assets/images/icons/SVG/health-track-${this.props.theme === 'yellow' ? 'black' : 'yellow'}.svg`}" width="70px" height="70px" aria-labelledby="interactive-pdf-icon"/>
                        <p id="interactive-pdf-icon"><span class.redact-white2="{this.props.theme !== 'yellow'}" class.redact2="{this.props.theme === 'yellow'}">Health tracking apps</span></p>
                    </div>
                </div>
            </If>
            
        </div>
    </Collapsible>
</div>
</template>

<script>
    import {
        createRef
    } from 'rmlibrary/comp';
    import {
        scrollIntoView
    } from "rmlibrary/react-scroll-into-view";
    import {
        GalleryCarousel
    } from 'rmlibrary/carousel/gallery-carousel';
    
    import {CustomizationConsumer} from "../../common/customization";
    import {trackLearnMore, trackPortfolio} from '../../../tracking';

    export function InteractiveTools(props) {
        return (<CustomizationConsumer>
            {(customizationState) => <InteractiveTools__ {...props} 
            specialIndustry={customizationState.specialIndustry}
            industry={customizationState.industry} /> }
        </CustomizationConsumer>)
    }
    InteractiveTools.PASS_COLOUR = true;

    /* srcObj contains the srouces for preloaded video and images of BannerItem */
    let srcObj = {};

    /* video/image preloader function */
    function fetchSrc(source) {
        if (!srcObj[source]) {
            fetch(source)
            .then((response) => response.blob())
            .then((data) => {
                srcObj[source] = URL.createObjectURL(data);
                return srcObj[source];
            }).
            catch((err) => console.log(err));  
        } else {
            return srcObj[source];
        }
    }
    
    function BannerItem(props) {
        const {phoneVideoSrc, phoneImgSrc, ...otherProps} = props;
        let imageSrc = fetchSrc(phoneImgSrc);
        let videoSrc = fetchSrc(phoneVideoSrc);

        return (<div {...otherProps}>
            <div class="screen_contain">
                <div class="phone_vid" style={{backgroundImage: `url('${imageSrc}')`}}>
                    <video preload="auto" autoPlay={true} muted={true} loop={true} playsInline={true} webkit-playsinline={"true"} src={videoSrc} ></video>
                </div>
                <div class="hand_contain">
                    <img class="hand" src="site_assets/images/banner-bgs/hand-transparent.png" alt="hand holding phone"/>
                </div>
            </div>
        </div>);
    }

    class InteractiveToolsController extends Component {
        constructor(props) {
            super(props);

            this.scrollRef = createRef();

            this.state = {
                index: 0,
                galleryImages: [],
                isOpen: false
            }

            this.jumpingToCard = false;

            this.galleryCallbefore = this.galleryCallbefore.bind(this);
            this.toggleAccordion = this.toggleAccordion.bind(this);
            this.portfolioClick = this.portfolioClick.bind(this);
            this.accordionOpened = this.accordionOpened.bind(this);
        }

        componentDidMount() {
            this.setState({
                galleryImages: this.gallery.props.children
            });
        }

        indicatorsRedirect(card, index, e) {
            if (!this.gallery.isBusy()) {
                this.setState({
                    index
                });
                this.jumpingToCard = true;
                this.gallery.jumpToCard(card, index);
            } else this.selectedBtn.focus();
        }

        galleryCallbefore(increment) {
            if (increment != 0) {
                let scrollIndex = (this.state.index + increment + this.state.galleryImages.length) % this.state.galleryImages.length;

                let nextIndex = this.jumpingToCard ? this.gallery.getIndex() : scrollIndex;

                this.setState({
                    index: nextIndex
                });
                this.jumpingToCard = false;
            }
        }

        toggleAccordion() {
            if (!this.state.isOpen) {
                trackLearnMore("interactive-tools", "Interactive Tools");
            }
            this.setState({
                isOpen: !this.state.isOpen
            });
        }

        portfolioClick() {
            trackPortfolio("interactive-tools");
        }

        accordionOpened() {
            if (!this.scrollRef.current) return;
            let offsetTop = document.querySelector(".nav-wrapper").offsetHeight;
            scrollIntoView(this.scrollRef.current, {
                block: 'center',
                behavior: 'smooth',
                viewportBox: {
                    top: offsetTop
                }
            });
        }
    }

</script>
